export default __webpack_public_path__ + "static/lightModeTalus-f701ae279a07287106a4fc0e6b61f820.png";